/**********************************************************************************************************************/
/**********************************************************************************************************************/
/* FILE: hafas_webapp_controller_eventsearch.js                                                                         */
/**********************************************************************************************************************/
/* Controller EventSearch */

/**
 * @class this.Controller.EventSearch
 */
HafasWebapp.prototype.Controller.EventSearch = {
  focusSelector: null, // for restoring focus after some action is performed
  /**
   * @class this.Controller.EventSearch.index
   *
   * @param data
   */
  index: function(data){
    var me = this;
    var controller = me.Controller.EventSearch;

    if(Hafas.Modules.History){
      var histData = data || {};
      Hafas.Modules.History.addData("EventSearch", "index", histData);
    }

    var model = {};

    // kategorie-filter
    //...

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');
    Hafas.ps.pub('/GUI/form/hide', [{appcontext: 'EventSearch'}]);

    // hide resultContainer if there are older results
    Hafas('#' + me.formContainer, false).innerHTML = '';
    Hafas('#EventSearch_ResultOverview', false).innerHTML = '';

    // clear Map if there is older content
    this.Controller.EventSearch.clearMap.bind(this)();

    // achtung: es wird in den overview-container gerendert
    Hafas.Modules.Render.render({
      file: 'eventsearch.index.html',
      target: 'EventSearch_ResultOverview',
      template: 'EventSearch_TplIndex',
      model: model
    }, Hafas.bind(function () {

      Hafas.ps.pub('/GUI/results/overview/show', [{}]);

      // date time picker initialisieren, falls aktiviert
      //if(Hafas.Config.EventSearch.useDateFilter === true) {
        // timedate picker
        var sDTPConfig = {
          holder: "HFS_EventSearchDateTimePickerHolder",
          id: "EventSearch_date",
          config: {
            useDepArrSwitch: false,
            useTimePicker: false,
            useNowMode: false,
            useInvertedClickArea: true,
            useDateTexts: true
          },
          current: {
            date: controller.instance.getDate()
          }
        };
        controller.sDateDTP = Hafas.Core.newType('hafasTimeDatePicker', sDTPConfig);
      //}

      Hafas.ps.pub('/GUI/form/show', [{}]);
      Hafas.ps.pub('/GUI/window/scrollTo', ['top']);
      Hafas.ps.pub('/app/events/renderDone');
      Hafas.ps.pub('/app/events/grunticon');

      // Track
      Hafas.ps.pub('/tracking/screen/eventsearch-main');

      Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/contextLoaded/' + me.appContext);

      // restore aus history?
      if((typeof data !== 'undefined') && (typeof data.events !== 'undefined')){
        Hafas.bind(controller.showResultOverview, me)(data);
      }
      // ansonsten initial suchen
      else{
        controller.mapLocations = [];
        Hafas.ps.pub('/EventSearch/postForm');
      }

    }, this));

  },

  postForm: function (data) {
    if ((typeof data !== 'undefined') && (typeof data.ev !== 'undefined')){
      data.ev.preventDefault();
    }

    // close all additional resultcontainer
    Hafas.ps.pub('/GUI/results/additional/hideAll');

    // loader
    Hafas.Modules.Render.render({
      file: 'eventsearch.index.html',
      target: 'HFS_EventSearchOverviewResults',
      template: 'Common_AtomTplLoaderSmall',
      model: {}
    });

    this.Controller.EventSearch.instance.search({
      callback:Hafas.bind(this.Controller.EventSearch.showResultOverview, this)
    });

    // karte leeren
    Hafas.bind(this.Controller.EventSearch.clearMapContent, this)();
    Hafas.bind(this.Controller.EventSearch.removeFlyoutFromMap, this)();

    // Track
    Hafas.ps.pub('/tracking/event/eventsearch-request', [{ type: 'EventSearch' }]);

    Hafas.ps.pub('/GUI/tabs/closeAll');
    Hafas.ps.pub('/GUI/options/closeAll');

    Hafas.ps.pub('/app/events/resize');
    return false;
  },

  showResultOverview: function (response) {

    var me = this;
    var controller = me.Controller.EventSearch;

    if(Hafas.Modules.History) {
      Hafas.Modules.History.updateData("EventSearch", "index", response);
    }

    if (typeof Hafas.Config.showDataModel !== 'undefined' && Hafas.Config.showDataModel) {
      console.log('+++ EventSearch.showResultOverview +++ DEBUG Model +++', response)
    }


    response.uid = '';
    response.expandMode = '';

    Hafas.Modules.Render.render({
      file: 'eventsearch.index.html',
      target: 'HFS_EventSearchOverviewResults',
      template: 'EventSearch_TplOverview',
      model: response
    }, Hafas.bind(function () {
      if (this.Controller.EventSearch.focusSelector) {
        Hafas.Util.gui.restoreFocus(this.Controller.EventSearch.focusSelector);
        this.Controller.EventSearch.focusSelector = null; // avoid unintentionally restoring focus later on
      } else {
        Hafas.Util.gui.focusTabOrMenuButton();
      }

      Hafas.ps.pub('/GUI/results/overview/show', [{}]);

      // is defined in classic-Version GUI-Functions
      Hafas.ps.pub('/GUI/window/scrollTo', ['top']);

      // auf karte anzeigen
      if (this.Controller.Map.instance) {
        Hafas.bind(controller.showDataOnMap, me)();

        // karte auf alle meldungen zentrieren/zoomen
        Hafas.bind(controller.centerDataOnMap, me)();
      }

      // Track
      Hafas.ps.pub('/tracking/screen/eventsearch-overview', [{}]);

      Hafas.ps.pub('/GUI/results/resize', [{container: me.resultOverviewContainer, appcontext: me.appContext}]);
      Hafas.ps.pub('/app/events/resize');

    }, this));

  },

  toggleDetails: function (data) {
    this.Controller.EventSearch.focusSelector = Hafas.Util.gui.getFocusElementSelector();

    if (typeof data.ev != 'undefined') {
      data.ev.preventDefault();
      data.ev.stopPropagation();
    }

    var me = this;
    var controller = me.Controller.EventSearch;
    var results = controller.instance.getResults();

    var currEvent = results.events[data.eventX];

    if (Hafas.Modules.History){
      Hafas.Modules.History.addOrUpdateData("EventSearch", "details", currEvent);
    }

    Hafas.bind(controller.renderDetails, me)(currEvent);
    Hafas.ps.pub('/renderer/renderDone');
  },

  renderDetails: function(currEvent){
    var me = this;
    var controller = me.Controller.EventSearch;
    var results = controller.instance.getResults();

    // small layout und karte noch angezeigt? dann die ausblenden
    if(me.layoutClass === 'small') {
      var mapDiv = Hafas('#'+me.mapContainer,false);
      if(mapDiv && (mapDiv.style.visibility === 'visible')){
        Hafas.ps.pub('/GUI/map/hide', []);
      }
    }

    // ort in karte zeigen (bzw. fuer small schon vorab zentrieren)
    Hafas.bind(controller.centerEventOnMap, me)(currEvent);

    Hafas.Modules.Render.render({
      file: 'eventsearch.index.html',
      target: 'EventSearch_ResultDetail',
      template: 'EventSearch_TplDetail',
      model: currEvent
    }, function (html) {

      // Track
      Hafas.ps.pub('/tracking/screen/eventsearch-details');

      Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
      Hafas.ps.pub('/GUI/results/details/show', [{}]);

      Hafas.ps.pub('/app/events/resize');
      Hafas.ps.pub('/app/events/resize', [{appcontext: me.appContext, method: 'eventsearch/toggleDetails'}]);

      // Focus back button
      Hafas.Util.gui.focusFirstElement('#HFS_DocumentDetailOverview');

    });

    // close all open tabs
    Hafas.ps.pub('/GUI/tabs/closeAll');
    Hafas.Util.gui.resetScrollTop();
  },

  iframeLoaded: function () {
    var loader = Hafas('#HFS_EventSearch_DetailLoader',false);
    if(loader){
      loader.style.display = 'none';
    }
  },

  // datum setzen
  setDate: function (date,time,forward,timenow) {
    var me = this;
    var controller = me.Controller.EventSearch;

    controller.instance.setDate(date);

    // und neu suchen
    Hafas.ps.pub('/EventSearch/postForm');

  },

  // anzeige aller eventlocations auf der karte
  showDataOnMap: function () {

    var me = this;
    var controller = me.Controller.EventSearch;
    var results = controller.instance.getResults();

    if(controller.mapLocations.length == 0){
      results.locations.forEach(function(loc){
        Hafas.bind(controller.showLocationOnMap, me)(loc);
      });
    }

  },

  // eventlocation anzeigen
  showLocationOnMap: function (loc) {

    var me = this;
    var controller = me.Controller.EventSearch;
    var com = controller.instance.data.results.common;
    var events = controller.instance.data.results.events;
    var map = me.Controller.Map.instance;

    var coord = Hafas.Core.newType("hafasCCoord", {
      lon: loc.crd.x, lat: loc.crd.y
    });

    var imageheight = 30;
    var imagewidth = 30;
    var hotspot = {x: 15, y: 15};

    // als icon wird das des ersten referenzierten events verwendet
    var image = Hafas.Util.getImage(com.icoL[events[loc.events[0]].eventResolved.icoX].res);

    var params = {
      type: "location",
      cluster: "eventSearch",
      clusterText: function(cluster){
        return cluster.getChildCount()+ ' ' + Hafas.Modules.i18n.get('EventSearch.t_N_ClusterPopup');
      },
      clusterOnclick: function(cluster){
        //Hafas.ps.pub('/EventSearch/clickOnCluster');
      },
      coord: coord,
      imageurl: image,
      imageheight: imageheight,
      imagewidth: imagewidth,
      text: loc.name,
      hotspot: hotspot,
      hotspotType: "fraction",
      imagescale: 0.5,
      //selectable: true,
      onclick: function (loc, common, that) {
        return function (map, markerParams) {
          Hafas.ps.pub('/map/clickOnLocation', [that.Controller.Map.instance, loc, common, markerParams]);
          Hafas.bind(controller.showEventsInToolbox, me)(loc);
        };
      }(loc, com, me)
    };

    var tmpIcon = map.createContent(params);

    controller.mapLocations.push(tmpIcon);
    map.showContent(tmpIcon);

  },

  showEventsInToolbox: function(loc){
    var me = this;
    var controller = me.Controller.EventSearch;
    var results = controller.instance.getResults();

    if(typeof loc.events !== 'undefined'){
      var model = {
        events:[]
      };

      loc.events.forEach(function(evtX){
        model.events.push(results.events[evtX]);
      });

      model.uid = '';
      model.expandMode = '';

      Hafas.Modules.Render.render({
        file: 'eventsearch.index.html',
        target: 'HFS_ToolboxLocationEvents',
        template: 'EventSearch_TplMap',
        model: model
      }, Hafas.bind(function () {
        Hafas('#HFS_ToolboxLocationEvents',false).removeAttribute('aria-hidden');
        Hafas('#HFS_ToolboxLocationEvents',false).removeAttribute('hidden');
      }, this));

    }
  },

  // flyout ausblenden
  removeFlyoutFromMap: function () {
    var me = this;
    var map = me.Controller.Map.instance;

    map.removeToolboxItem('mapSelection','id');
  },

  // icon von karte entfernen
  clearMapContent: function(){
    var me = this;
    var controller = me.Controller.EventSearch;
    var map = me.Controller.Map.instance;

    if (controller.mapLocations){
      controller.mapLocations.forEach(function(removeIcon){
        map.hideContent(removeIcon);
        map.removeContent(removeIcon);
      });
    }

    controller.mapLocations = [];
  },

  // karte auf alle events zentrieren/zoomen
  centerDataOnMap: function(){

    var me = this;
    var controller = me.Controller.EventSearch;
    var results = controller.instance.getResults();
    var map = me.Controller.Map.instance;
    var allCoords = [];

    results.locations.forEach(function(loc){

      allCoords.push(Hafas.Core.newType("hafasCCoord", {
        lon: loc.crd.x, lat: loc.crd.y
      }));
    });

    if(allCoords.length > 0){
      Hafas.Util.maps.centerToCoords(allCoords,map);
    }

  },

  centerEventOnMap: function(data){
    var me = this;
    var controller = me.Controller.EventSearch;
    var results = controller.instance.getResults();
    var map = me.Controller.Map.instance;

    var loc = results.locations[data.locX];

    // location auswaehlen
    Hafas.ps.pub('/map/clickOnLocation', [map, loc, results.common]);
    Hafas.bind(controller.showEventsInToolbox, me)(loc);

    var toolboxItem = map.getToolboxItem('mapSelection');
    var toolboxHeight = toolboxItem.elem.offsetHeight;

    // map offset setzen, damit die meldung nicht hinter dem flyout zentriert wird
    var currMapOffset = map.getOffset();
    map.setOffset({y2:toolboxHeight});

    if(me.layoutClass == 'small') {
      map.setOffset({y:50,x:10,x2:10});
    }

    var allCoords = [];
    allCoords.push(Hafas.Core.newType("hafasCCoord", {
      lon: loc.crd.x, lat: loc.crd.y
    }));
    if(allCoords.length > 0){
      Hafas.Util.maps.centerToCoords(allCoords,map);
      map.setOffset(currMapOffset);
    }
  },

  planTrip: function(locKey,date,time){
    var location = Hafas.Modules.Render.objectKeeper.get(locKey);
    var me = this;

    var applyFunction = function(){

      // pruefen, ob tp fertig ist
      if(me.Controller.TP.currentView === 'index'){
        me.Controller.TP.instance.setLocation('arr', location);
        //Hafas.ps.pub('/map/select',['arr',location]);
        Hafas.ps.pub('/tp/setEnquiry', [false]);
        Hafas.ps.pub('/tp/setDate', [date]);
        Hafas.ps.pub('/tp/setTime', [time]);
      }
      else{
        window.setTimeout(function(){
          applyFunction();
        },200);
      }

    };

    // zu tp wechseln
    Hafas.ps.pub('/app/switchContext', [{context: 'TP', method: 'index'}]);

    // daten uebergeben
    applyFunction();

  },

  resize: function(){
    // ueberhaupt im richtigen kontext?
    if(this.appContext === 'EventSearch'){

      var detailDiv = Hafas('#EventSearch_ResultDetail .lyr_resultsWrap',false);
      if(detailDiv) {
        detailDiv.style.height = '';
        detailDiv.style.height = (window.innerHeight - parseInt(detailDiv.style.marginTop,10))+ 'px';
      }

    }
  },
  /**
   * Clear map content that was created by the event search
   *
   * @method clearMap
   */
  clearMap: function(){
    var me = this;
    var controller = me.Controller.EventSearch;
    // Clear map
    Hafas.bind(controller.clearMapContent, me)();

    // Close flyout if necessary
    Hafas.bind(controller.removeFlyoutFromMap, me)();
  },
  cleanup: function () {
    var me = this;
    this.Controller.EventSearch.clearMap.bind(this)();
  },
  leaveContext: function () {
    var me = this;
    var controller = me.Controller.EventSearch;

    Hafas.bind(controller.cleanup,me)();

    // inhalte entfernen
    Hafas('#' + me.formContainer, false).innerHTML = '';
    Hafas('#EventSearch_ResultOverview', false).innerHTML = '';
    Hafas('#EventSearch_ResultDetail', false).innerHTML = '';
  },

  closeView: function(histData) {
    var me = this;
    var controller = me.Controller.EventSearch;

    switch(histData.view)
    {
      case "index":
        Hafas.ps.pub('/GUI/results/overview/hide', [{}]);
        break;
      case "details":
        Hafas.ps.pub('/GUI/results/details/hide', [{}]);
        break;
      case "map":
        // ggf toolbox schliessen
        Hafas.bind(controller.removeFlyoutFromMap, me)();
        Hafas.ps.pub('/GUI/map/hide', []);
        break;
    }

  },
  restoreView: function(histData) {
    var me = this;
    var controller = me.Controller.EventSearch;

    var view = histData.view;
    switch(view) {
      case "index":
        Hafas.bind(controller.index, me)(histData.data);
        break;
      case "details":
        Hafas.bind(controller.renderDetails, me)(histData.data);
        break;
      case "map":
        Hafas.ps.pub('/GUI/map/show', [{template: 'Common_MapPageHeaderDefault'}]);
        break;
    }
  },

  /**
   * clears all input data (including options)
   *
   * @method
   */
  clearInput: function () {
    // Entferne aktuellen History-Eintrag, da nachfolgend über switchContext ein neuer hinzu kommt
    Hafas.Modules.History.removeCurrentStep("index", () => {
      Hafas.ps.pub('/app/switchContext', [{context: 'EventSearch', method: 'index'}]);
    });

    var me = this;
    me.Controller.EventSearch.sDateDTP.setTimeNowOn(); // Default Date aus dem EventSearch-Modul

    Hafas.Modules.a11y.Announce.assertive(Hafas.Modules.i18n.get('common.menu.t_N_clearInput_success'));
  }

};
